<a href="#sortCol" (click)="onSortClick($event)">
  <ng-content />
  @if (sortingAsc) {
    <span>&#x25B2;</span>
    } @if (sortingDesc) {
    <span>&#x25BC;</span>
  }
</a>
